<template>
	<div class="curation-edit-color-wrapper">
		<div class="curation-edit-color-title-wrapper">
			<p class="title">전체 색상 변경</p>
			<div class="div-line"></div>
		</div>

		<div class="color-group">
			<span class="title">짧은 와인 이름 색상</span>
			<layout-color-selector v-model="editableColorPalette.shortWineName" />
		</div>

		<div class="color-group">
			<span class="title">큐래이션 짧은 설명 색상</span>
			<layout-color-selector v-model="editableColorPalette.curationDsc" />
		</div>

		<div class="color-group">
			<span class="title">가격 색상</span>
			<layout-color-selector v-model="editableColorPalette.price" />
		</div>

		<div class="color-group">
			<span class="title">가격 배 색상</span>
			<layout-color-selector v-model="editableColorPalette.priceBg" />
		</div>
	</div>
</template>

<script>
import LayoutColorSelector from "@/spa/components/LayoutColorSelector";

export default {
	name: "CurationEditColor",
	components: {
		LayoutColorSelector
	},
	props: {
		changeCurationWineColor: Function
	},
	watch: {},

	data() {
		return {
			editableColorPalette: {
				shortWineName: "#666666",
				curationDsc: "#999999",
				price: "#666666",
				priceBg: "#ffffff"
			}
		};
	}
};
</script>

<style lang="scss" scoped>
.curation-edit-color-wrapper {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;

	justify-content: center;
	align-items: center;
	align-content: center;

	width: 650px;

	box-shadow: 0 4px 24px rgba(0, 0, 0, 0.04);
	background-color: rgb(255, 255, 255);

	padding-top: 15px;
	padding-bottom: 15px;
	margin-top: 15px;

	margin-bottom: 10px;

	.curation-edit-color-title-wrapper {
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;

		.title {
			width: 100%;
			text-align: left;
			padding-left: 25px;
			font-size: 16px;

			padding-bottom: 30px;
			margin: 0;
		}

		.div-line {
			width: 90%;
			height: 1px;
			background-color: rgba(0, 0, 0, 0.1);
			margin-bottom: 30px;
		}
	}

	.color-group {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
		align-content: center;

		margin-bottom: 10px;

		.title {
			padding-left: 10px;
			padding-right: 20px;
			width: 170px;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/spa/components/board/curation/detail-row/curation-wine-list/CurationEditColor.vue